<div fxFlex="100%" fxLayoutAlign="start center">
    <div class="mr-5" *ngIf="src" fxLayout="column" fxLayoutAlign="center">
        <img [src]="src" class="profile" alt="avatar" width="40px" height="40px">
    </div>
    <div fxLayout="column" [style.width]="style.width">
        <span class="ellipses">{{userId}}</span>
        <span *ngIf="src" class="light-gray ellipses">{{userName}}</span>
    </div>
</div>